import Kfit from '../integrations/Kfit';

export const activateFavepay = params =>
  Kfit.put('/v1/favepay/activate_favepay', params).then(res => res);
